import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of } from 'rxjs';

import { TypeExpensesService } from 'src/app/shared/services/type-expenses.service';
import {
  loadTypeExpenses,
  loadTypeExpensesSuccess,
} from './type-expenses.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class TypeExpensesEffects {
  constructor(
    private service: TypeExpensesService, 
    private action$: Actions,
    private notify: NotifyService
  ) {}

  loadTypeExpenses$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadTypeExpenses),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadTypeExpensesSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );
}
